// src/utils/device.js
// Device ki unique pehchan browser mein persist karta hai (ek baar banega,
// phir localStorage se hamesha wahi milega — jaisे mobile app ka deviceId)

export const getOrCreateDeviceId = () => {
  const STORAGE_KEY = 'deviceId';
  let deviceId = localStorage.getItem(STORAGE_KEY);

  if (!deviceId) {
    // crypto.randomUUID() modern browsers mein available hai; fallback bhi rakha hai
    deviceId = (typeof crypto !== 'undefined' && crypto.randomUUID)
      ? crypto.randomUUID()
      : `web-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem(STORAGE_KEY, deviceId);
  }

  return deviceId;
};

// Browser/OS se ek readable device name bana dete hain (backend ke
// deviceName field ke liye — user-agent se simple guess)
export const getDeviceName = () => {
  const ua = navigator.userAgent;
  if (/android/i.test(ua))       return 'Android Browser';
  if (/iphone|ipad|ipod/i.test(ua)) return 'iOS Browser';
  if (/windows/i.test(ua))       return 'Windows Browser';
  if (/mac os/i.test(ua))        return 'Mac Browser';
  if (/linux/i.test(ua))         return 'Linux Browser';
  return 'Web Browser';
};

// Backend ka enum sirf 'android' | 'ios' | 'web' accept karta hai
export const DEVICE_TYPE = 'web';